import { RESET_VALIDATE_SNAPSHOT, VALIDATE_SNAPSHOT } from "../../actionTypes/actionsTypes";
import defaultAsyncReducer from "../../defaultReducer";
import { AppAction, BaseAsyncReducerState, LocalAction } from "../../types";

export interface ValidateSnapshotState extends BaseAsyncReducerState {
  checked: boolean,
  errorSummary: [],
  errors: []
}

const initialState: ValidateSnapshotState = {
  checked: false,
  success: false,
  message: "",
  error: false,
  loading: false,
  errors: [],
  errorSummary: []
}

function getValidateSnapshotReducer(state = initialState, action: AppAction | LocalAction) {
  if (action.type === RESET_VALIDATE_SNAPSHOT) {
      return initialState
    } else {
      return defaultAsyncReducer(state, action as AppAction, VALIDATE_SNAPSHOT)
    }
}

export default getValidateSnapshotReducer;
